import { Stack, Typography, Divider } from '@mui/material';
import { BackupPolicyType } from '@repo/api-gw-sdk';

import { useEnvironment } from '@/contexts/useEnvironment';
import { ResourceTypes } from '@/data/inventory/resourceTypes';

import { useHighFrequencySupportedResourceTypes } from './highFrequencySupportedResourceTypes';

export const HighFrequencySupportedDisclaimer = ({
  policyType,
}: {
  policyType: BackupPolicyType;
}) => {
  const { isDemo } = useEnvironment();
  const highFrequencySupportedResourceTypes =
    useHighFrequencySupportedResourceTypes();

  return (
    <>
      {!isDemo &&
        policyType === BackupPolicyType.BACKUP_POLICY_TYPE_HIGH_FREQUENCY && (
          <Stack gap='2px'>
            <div />
            <Typography
              padding='12px 40px'
              align='center'
              className='bg-[var(--mui-palette-background-page)]'
            >
              {`High-frequency backup policy. Available for ${highFrequencySupportedResourceTypes.map((x) => ResourceTypes[x].displayName).join(', ')} only.`}
            </Typography>
            <Divider />
          </Stack>
        )}
    </>
  );
};
